/**
 * 初期処理
 *
 **/
$(window).on('load', function() {

  // 見学希望日表示制御
  oh_change_show_observe_date();

  // 見学希望時刻の各種制御
  oh_init_observe_time();

  // 希望地域の制御
  oh_kibou_chiiki();

  // 沿線・駅のブロック制御
  oh_railway_more();

  // 連絡方法選択時の制御
  oh_click_contact_way();

  // お問合せ内容「質問や相談をしたい」選択時
  oh_toggle_class_cond_etc_txt();

});


/**
 * 鉄道会社設定
 *
 **/
(function () {
  $("#railway1, #railway2, #railway3").on('change', function(el) {

    var kbn = '';
    switch ($(this).attr('id')){
      case 'railway1':
        kbn = '1'
        break;
      case 'railway2':
        kbn = '2'
        break;
      case 'railway3':
        kbn = '3'
        break;
    }

    if ($(this).valid() && kbn != '') {
      var data = {railway:$("option:selected", this).val()};
      oh_set_rwcompany(RAILWAY_API_URL, kbn, data);
    }

  });
}());

/**
 *
 * @param {*} url
 * @param {*} kbn
 * @param {*} data
 */
var oh_set_rwcompany = function(url, kbn, data) {
  $.ajax({
    mode: "abort",
    type: "get",
    url: url,
    data: data,
    dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    // error: function(xhr, status, exception){alert("error:" + status);},
    success: function(params, status){oh_set_rwcompany_callback(params,kbn)}
  });
};

/**
 * 沿線情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 * @param {*} kbn
 */
var oh_set_rwcompany_callback = function(params,kbn) {
	var node_parent = $('#line' + kbn);
	node_parent.empty();
	var node_default = $('<option />', {'id':'line' + kbn + '_0','value':'0','selected':'selected'});
	node_parent.append(node_default);
	for(var cd in params['list']){
		var value = cd
		var id = 'line' + kbn + '_' + cd;
		var content = params['list'][cd];
		var node = $('<option />', {'id':id,'value':value}).text(content);
		node_parent.append(node);
	}

	var node_parent_station_from = $('#stationFrom' + kbn);
	var node_parent_station_to = $('#stationTo' + kbn);
	node_parent_station_from.empty();
	node_parent_station_to.empty();
	var node_default_station_from = $('<option />', {'id':'stationFrom' + kbn + '_0','value':'0','selected':'selected'});
	var node_default_station_to = $('<option />', {'id':'stationTo' + kbn + '_0','value':'0','selected':'selected'});
	node_parent_station_from.append(node_default_station_from);
	node_parent_station_to.append(node_default_station_to);

	//必須バックカラー制御
	// require_line();
};

/**
 * 沿線の設定
 *
 */
(function () {
  $("#line1, #line2, #line3").on('change', function(el) {

    var kbn = '';
    switch ($(this).attr('id')){
      case 'line1':
        kbn = '1'
        break;
      case 'line2':
        kbn = '2'
        break;
      case 'line3':
        kbn = '3'
        break;
    }

    if ($(this).valid() && kbn != '') {
      var data = {line:$("option:selected", this).val()};
      oh_set_line(LINE_API_URL, kbn, data);
    }

  });
}());

/**
 * 沿線を設定する
 * @param {*} url
 * @param {*} kbn
 * @param {*} data
 */
var oh_set_line = function(url, kbn, data)
{
  $.ajax({
    mode: "abort",
    type: "get",
    url: url,
    data: data,
    dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    // error: function(xhr, status, exception){alert("error:" + status);},
    success: function(params, status){oh_set_line_callback(params,kbn)}
  });
};

/**
 * 駅情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 * @param {*} kbn
 */
var oh_set_line_callback = function(params,kbn)
{
  var node_parent_from = $('#stationFrom' + kbn);
  var node_parent_to = $('#stationTo' + kbn);
  node_parent_from.empty();
  node_parent_to.empty();
  var node_default_from = $('<option />', {'id':'stationFrom' + kbn + '_0','value':'0','selected':'selected'});
  var node_default_to = $('<option />', {'id':'stationTo' + kbn + '_0','value':'0','selected':'selected'});
  node_parent_from.append(node_default_from);
  node_parent_to.append(node_default_to);
  var over_100_cd_list = {};
  for(var cd in params['list']){
    if (cd < 100) {
      var id_from = 'stationFrom' + kbn + '_' + cd;
      var id_to = 'stationTo' + kbn + '_' + cd;
      var value = params['list'][cd]['station_cd'];
      var content = params['list'][cd]['station_snm'];
      var node_from = $('<option />', {'id':id_from,'value':value}).text(content);
      var node_to = $('<option />', {'id':id_to,'value':value}).text(content);
      node_parent_from.append(node_from);
      node_parent_to.append(node_to);
    } else {
      over_100_cd_list[cd] = params['list'][cd];
    }
  }
  for(var cd in over_100_cd_list) {
    var id_from = 'stationFrom' + kbn + '_' + cd;
    var id_to = 'stationTo' + kbn + '_' + cd;
    var value = params['list'][cd]['station_cd'];
    var content = params['list'][cd]['station_snm'];
    var node_from = $('<option />', {'id':id_from,'value':value}).text(content);
    var node_to = $('<option />', {'id':id_to,'value':value}).text(content);
    node_parent_from.append(node_from);
    node_parent_to.append(node_to);
  }
};

/**
 * もっと設定する押下
 *
 */
(function () {
  $("#more1").on('click', function(el) { oh_open_railway_input(1);});
  $("#more2").on('click', function(el) { oh_open_railway_input(2);});
}());

/**
 * もっと設定する押下
 * @param {*} rlNo
 */
var oh_open_railway_input = function(rlNo) {
	nrlNo = rlNo + 1;
	$('#more' + rlNo).hide();
	$('#more' + nrlNo).show();
	$('#railwayBlock' + nrlNo).show();
};

/**
 * 『さらに詳しく設定する』制御
 */
var oh_railway_more = function() {
  RWCompany2 = $('#railway2').val();
  RWCompany3 = $('#railway3').val();
  if ((RWCompany2 != undefined && RWCompany2 != 0) || (RWCompany3 != undefined && RWCompany3 != 0)) {
    if (RWCompany3 != undefined && RWCompany3 != 0) {
      $('#more1').hide();
      $('#more2').hide();
      $('#railwayBlock2').show();
      $('#railwayBlock3').show();
    } else {
      $('#more1').hide();
      $('#more2').show();
      $('#railwayBlock2').show();
      $('#railwayBlock3').hide();
    }
  } else {
    $('#more1').show();
    $('#more2').hide();
    $('#railwayBlock2').hide();
    $('#railwayBlock3').hide();
  }
};

/**
 * 市区町村選択情報 初期化
 *
 */
(function () {
  $("#area").on('change', function(el) {
    oh_reset_selected_city();
    // if ($(this).valid() && kbn != '') {}

  });
}());

/**
 * バックアップ用のグローバル変数
 */
var oh_popup_area_backup = {};

/**
 * 市区町村選択時に市区町村選択情報を初期化する
 */
var oh_reset_selected_city = function() {
	oh_popup_area_backup = {};
	$('#selected_area').empty();
	$('#selectedCityText').empty();
};

/**
 * 市区町村選択情報 ポップアップ
 *
 */
(function () {
  $("#selectedCityLink").on('click', function(el) {
    // $(window).off('beforeunload');
    oh_show_popup_area(AREA_API_URL);
  });
}());

/**
 * 市区町村選択ポップアップ表示時に呼び出される関数
 * @param {*} url
 */
var oh_show_popup_area = function(url) {
	areaCd = $('#area option:selected').val();
	if (areaCd == '0' || areaCd == null || areaCd == '') {
		alert("エリアが選択されていません");
	} else {
	  oh_create_popup_area_backup();
	  oh_create_popup_area(url,areaCd);
	}
};

/**
 * 市区町村選択ポップアップ表示時にhidden情報を保存領域に設定
 */
var oh_create_popup_area_backup = function() {
	var city_list = $('#selected_area :hidden[id^=city_]');
	city_list.each(function() {
		var city_info = {};
		city_info['checked'] = 'checked';
		oh_popup_area_backup[$(this).val()] = city_info;
	});
};

/**
 * 市区町村選択ポップアップのエリア情報を取得し、内容を変更する関数
 * @param {*} url
 * @param {*} areaCd
 */
var oh_create_popup_area = function(url,areaCd)
{
	data = {areaCd:areaCd};
	$.ajax({
    mode: "abort",
		type: "get",
		url: url,
		data: data,
		dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
		// error: function(xhr, status, exception){alert("error:" + status);},
		success: function(params, status){oh_create_popup_area_callback(params);}
	});
};

/**
 * 市区町村選択ポップアップのエリア情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 */
var oh_create_popup_area_callback = function(params) {

	var node_parent = $('#popup_area_select_list');
	node_parent.empty();

	var target_array = oh_popup_area_backup;
	$('#popup_area_nm').text(params['areaNm']);

	for(var cd in params['list']){
		var id = 'popup_area_cd_' + cd;
		var checked = null;
		if (oh_popup_area_backup != undefined && oh_popup_area_backup[cd] != undefined && oh_popup_area_backup[cd]['checked'] != undefined) {
			checked = oh_popup_area_backup[cd]['checked'];
		}

    var node_span = $('<span />');
    node_span.append($('<input />', {'type':'checkbox', 'id':id, 'value':cd, 'checked':checked}));
    node_span.append( $('<label/>', {'for':id}).text(params['list'][cd]));
		node_parent.append(node_span);
	}

	$('#popup_select_area').modal({clickClose:false});
};

/**
 * 市区町村選択ポップアップにて選択された市区町村情報を保存
 */
var oh_save_popup_area = function() {
	var temp_array = {};
	var area_cd = $('#popup_area_cd').val();
	var city_list = $('#popup_area_select_list :checkbox:checked');
	city_list.each(function() {
		var city_info = {};
		city_info['checked'] = 'checked';
		temp_array[$(this).val()] = city_info;
	});
	oh_popup_area_backup = temp_array;
};


/**
 * 市区町村選択情報 ポップアップ
 *
 */
(function () {
  $("#popup_submit").on('click', function(el) {
    // $(window).off('beforeunload');
    oh_set_popup_area(AREA_TEXT_API_URL);
  });
}());

/**
 * 市区町村選択ポップアップにて設定する
 * @param {*} url
 */
var oh_set_popup_area = function(url) {

	oh_save_popup_area();
	oh_set_popup_parameter_area();
	oh_set_popup_area_txt(url);
	oh_hide_popup_area();
};

/**
 * 市区町村選択ポップアップにて選択された市区町村情報を保存
 */
var oh_save_popup_area = function() {
	var temp_array = {};
	var area_cd = $('#popup_area_cd').val();
	var city_list = $('#popup_area_select_list :checkbox:checked');
	city_list.each(function() {
		var city_info = {};
		city_info['checked'] = 'checked';
		temp_array[$(this).val()] = city_info;
	});
	oh_popup_area_backup = temp_array;
};

/**
 * 市区町村選択ポップアップを閉じる
 */
var oh_hide_popup_area = function() {

	$('div').removeClass('blocker'); // モーダル解除
  $.modal.close();
	// $('#popup_select_area').hide();
};

/**
 * 選択された市区町村のテキストを設定する
 * @param {*} url
 */
var oh_set_popup_area_txt = function(url)
{
  var params = {};
  params["city_cd"] = oh_popup_area_backup;

  $.ajax({
    mode: "abort",
    type: "get",
    url: url,
    data: params,
    dataType: 'json',
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    // error: function(xhr, status, exception){alert("error:" + status);},
    success: function(params, status){oh_set_popup_area_txt_callback(params);}
  });
};

/**
 * 市区町村選択ポップアップの市区町村情報を取得し、内容を変更する関数(コールバック)
 * @param {*} params
 */
var oh_set_popup_area_txt_callback = function(params) {

  var node_parent = $('#selectedCityText');
  node_parent.empty();
  // var node_ul = $('<ul />') , i = 0;
  var i = 0;

  // 要素数
  var last_cd = -1;
  for(city_cd in params) {
    last_cd++;
  }

  for (city_cd in params) {
    if (i != last_cd) {
      var node_span = $('<span />').html(params[city_cd] + '&nbsp;/&nbsp;');
      node_parent.append(node_span);
      i++;
    } else {
      var node_span = $('<span />').html(params[city_cd]);
      node_parent.append(node_span);
      i++;
    }
  }
  // node_parent.append(node_ul);
};

/**
 * 市区町村選択ポップアップでの選択情報を親画面に設定する
 */
var oh_set_popup_parameter_area = function() {

  var node = $('#selected_area').empty();

  for (city_cd in oh_popup_area_backup) {
    var id = 'city_' + city_cd;
    var name = 'city_cd[]';
    var value = city_cd;
    var node_hidden = $('<input />', {'type':'hidden', 'id':id, 'name':name, 'value':value});
    node.append(node_hidden);
  }
};

/**
 * 希望地域の制御
 *
 */
(function () {
  $("[name='cond_area_setting_kbn']").on('change', function() {
    oh_kibou_chiiki();
  });
}());

/**
 * 希望地域の制御
 *
 */
var oh_kibou_chiiki = function() {
	var val = $("[name='cond_area_setting_kbn']:checked").val();
	if (val == "1") {
		$("#group_area").show();
		$("#group_railway").hide();
	} else if (val == "2") {
		$("#group_area").hide();
		$("#group_railway").show();
	} else {
		$("#group_area").hide();
		$("#group_railway").hide();
	}
};

/**
 * 連絡方法選択時の制御
 *
 */
(function () {
  $("[id^=contact_way]").on('change',function() {
		oh_click_contact_way();
	});
}());
var oh_click_contact_way = function() {
  oh_click_contact_way_toggle_class($('#customer_address1').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
  oh_click_contact_way_toggle_class($('#customer_address2').closest('.c-form-item__input-row').siblings('.c-form-item__label'));
};
var oh_click_contact_way_toggle_class = function ( el ) {
  // 初期化
  el.removeClass('--required');
  // クラス付与
  if ($('#contact_way4').prop('checked')) {
    el.addClass('--required');
  }
};

/**
 * 見学時間の表示制御
 *
 */
(function () {
  $("#contact_purpose_1").change(function() {
    oh_change_show_observe_date();
  });
}());
var oh_change_show_observe_date = function() {
  if($( "#contact_purpose_1" ).prop('checked')){
    $("#contact_purpose_1_detail").show();
  } else {
    $("#contact_purpose_1_detail").hide();
  }
};

/**
 * 見学希望時刻の制御
 */
var oh_init_observe_time = function() {
  // 見学希望時刻選択イベント
  $('#observe_start_hm_1, #observe_end_hm_1, #observe_start_hm_2, #observe_end_hm_2').on('change', function() {
    var no = $(this).attr('id').replace(/observe_(start|end)_hm_/,'');
    oh_change_observe_hm(no);
  });

  // 終日可選択イベント
  $('#observe_any_time_1, #observe_any_time_2').on('change', function() {
    var no = $(this).attr('id').replace('observe_any_time_', '');
    oh_change_observe_any_time(no);
  });

  // 初期処理
  oh_change_observe_hm(1);
  oh_change_observe_hm(2);
  oh_change_observe_any_time(1);
  oh_change_observe_any_time(2);
}

var oh_change_observe_hm = function(_no) {
  var $from = $('#observe_start_hm_' + _no);
  var $to = $('#observe_end_hm_' + _no);

  $from.find('option').each(function() {
    $(this).prop('disabled', $(this).val() != '' && $to.val() != '' && $to.val() <= $(this).val());
  })
  $to.find('option').each(function() {
    $(this).prop('disabled', $(this).val() != '' && $from.val() != '' && $from.val() >= $(this).val());
  });
};

var oh_change_observe_any_time = function(_no) {
  var $checkbox = $('#observe_any_time_' + _no);
  var $targets = $('#observe_start_hm_' + _no + ', #observe_end_hm_' + _no);
  $targets.val('');
  $targets.prop('disabled', $checkbox.prop('checked'));
};

/**
 * 質問・相談内容の必須/任意のラベル変更
 */
 (function () {
  $("#contact_purpose_3").change(function() {
    oh_toggle_class_cond_etc_txt();
  });
}());
var oh_toggle_class_cond_etc_txt = function () {

  label = $('#cond_etc_txt').closest('.c-form-item__input-row').siblings('.c-form-item__label');

  // クラス付与
  if ($("#contact_purpose_3").prop('checked')) {
    label.addClass('--required');
    label.removeClass('--optional');
  } else {
    label.addClass('--optional');
    label.removeClass('--required');
  }
};

/**
 * ふりがな自動入力
 */
 $(function() {
  $.fn.autoKana('#name', '#nameKana');
});
